import Tests from "./Tests.vue";

export default Tests;
